export const DEFAULT_TELEMETRY_LOOKBACK_DAYS = 30;
export const MIN_TELEMETRY_LOOKBACK_DAYS = 1;
export const MAX_TELEMETRY_LOOKBACK_DAYS = 180;
export const TELEMETRY_LOOKBACK_OPTIONS = [7, 14, 30, 60, 90, 180] as const;

export function normalizeTelemetryLookbackDays(
  value: number,
  fallback: number = DEFAULT_TELEMETRY_LOOKBACK_DAYS,
): number {
  if (!Number.isFinite(value)) {
    return fallback;
  }

  const rounded = Math.round(value);
  return Math.min(MAX_TELEMETRY_LOOKBACK_DAYS, Math.max(MIN_TELEMETRY_LOOKBACK_DAYS, rounded));
}
